<template>
  <div class="rating-line-block">
    <div class="name">{{ name }}</div>
    <div class="stars">
      <star v-for="i in 5" :key="i" :fill="value && value >= i" @click.native="select(i)" />
    </div>
  </div>
</template>

<script>
import Star from '@/components/icons/star'
export default {
  name: 'RatingLine',
  components: { Star },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: Number,
    name: String,
  },
  methods: {
    select(i) {
      this.$emit('change', i)
    },
  },
}
</script>

<style lang="scss">
.rating-line-block {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  font-size: 12px;
  line-height: 178.5%;

  &:not(:last-child) {
    margin-bottom: 6px;
  }

  .name {
    margin-right: 13px;
  }

  .stars {
    display: flex;

    .star-block {
      cursor: pointer;
      padding: 0 2px;

      &:hover ~ .star-block,
      &:hover {
        &::after {
          background-image: url('~@/assets/icons/star.svg');
        }
      }
    }

    &:hover {
      .star-block::after {
        background-image: url('~@/assets/icons/star-fill.svg');
      }
    }
  }
}
</style>
